import { render, staticRenderFns } from "./PotentialCustomerDetailsTabs.vue?vue&type=template&id=58ed3389&"
import script from "./PotentialCustomerDetailsTabs.vue?vue&type=script&lang=js&"
export * from "./PotentialCustomerDetailsTabs.vue?vue&type=script&lang=js&"
import style0 from "./PotentialCustomerDetailsTabs.vue?vue&type=style&index=0&id=58ed3389&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports